module.exports = __webpack_public_path__ + "portal-static/img/user_visitor.c1fb68a2.png";